export default __webpack_public_path__ + "static/media/Down.05b57039.svg";